/** @format */

import React, { PureComponent } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardBody from '../../../components/Card/CardBody';
import { BlockContainHelper, FieldsCondition, GetBlockStateViewProps } from '../../../modules/block/BlockContainHelper';
import { connect } from 'react-redux';
import { MvnoOperationsCollectionInterface } from '../../../interfaces/collections/MvnoOperationsCollectionInterface';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import MvnoOperation from '../../../interfaces/platform/MvnoOperation';
import { MvnoBlockStateViewHeader } from '../MvnoBlockStateViewHeader';
import { PlkViewObject } from '../../PlkFunctions/PlkViewObject';
import { LocalViewObject } from '../LocalViewObject';
import { OperatorMvneTypeMap } from '../../../modules/lib/hooks/useOperatorType';
import { OplFunctions } from '../../OplFunctions/OplFunctions';

interface GetStatusCalledViewState {
    mvnoOperation: MvnoOperationsCollectionInterface | null;
}

class DefaultCalledView extends PureComponent<GetBlockStateViewProps, GetStatusCalledViewState> {
    protected blockHelper = new BlockContainHelper();

    protected itemLoader: ItemLoaders;

    constructor(props: GetBlockStateViewProps, context: GetStatusCalledViewState) {
        super(props, context);
        this.state = {
            mvnoOperation: null,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        this.getPlkRequest();
    }

    getPlkRequest = (): void => {
        const { stateBlock } = this.props;
        const filter: Array<Filter> = [{ name: 'mvnoBlockRequestStateId', value: stateBlock.id }];
        const orders: Array<Order> = [{ name: 'id', value: 'asc' }];
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_operations')),
            'plus_orders_common_mvno_block',
            filter,
            orders,
            (data: MvnoOperationsCollectionInterface): void => {
                this.setState({ mvnoOperation: data });
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: true, propagateDataToCallback: true }
        );
    };

    render(): React.ReactNode {
        const { blockFunction, stateBlock, viewDialog, mvnoBlockRequest } = this.props;
        const { mvnoOperation } = this.state;

        const functionName = 'prov:f.' + blockFunction.displayName.trim().toLowerCase();
        let params: FieldsCondition | null = null;
        if (stateBlock.params) {
            params = this.blockHelper.getParams(stateBlock.params);
        }
        let color = 'grey';

        return (
            <Card>
                <MvnoBlockStateViewHeader
                    stateBlock={stateBlock}
                    functionName={functionName}
                    editColor={color}
                    cancelColor={color}
                    setGet={stateBlock.functionType}
                    mvnoBlockRequest={mvnoBlockRequest}
                />
                <CardBody>
                    {stateBlock.functionType !== 'LOCAL' &&
                        mvnoOperation &&
                        mvnoOperation['hydra:member'] &&
                        mvnoOperation['hydra:member'].map((item: MvnoOperation) => {
                            if (item.operatorType !== OperatorMvneTypeMap.OPL) {
                                return <PlkViewObject mvnoOperation={item} viewDialog={viewDialog} key={'plk_view_object_' + item.id} />;
                            } else {
                                return <OplFunctions mvnoOperation={item} viewDialog={viewDialog} key={'plk_view_object_' + item.id} />;
                            }
                        })}
                    {stateBlock.functionType === 'LOCAL' && (
                        <LocalViewObject
                            stateBlock={stateBlock}
                            viewDialog={viewDialog}
                            mvnoBlockRequest={mvnoBlockRequest}
                            mvnoBlockFunction={blockFunction}
                        />
                    )}
                </CardBody>
            </Card>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(DefaultCalledView);
